import { IconButton, Typography } from '@mui/material'
import { Facebook, Twitter, Instagram, Language, LinkedIn, GitHub } from '@mui/icons-material'
import { SocialLink } from '../../types'
import { translations } from '../../translations';

export function SocialLinks({ links, isRtl }: { links: SocialLink[], isRtl: boolean }) {
  const t = isRtl ? translations.ku : translations.en;
  return (
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', direction: isRtl ? 'rtl' : 'ltr' }}>
      {links.length === 0 && (
        <Typography variant="body1" color="text.secondary">
          {t.noSocialLinks}
        </Typography>
      )}
      {links.map((link) => (
          <IconButton size="small" href={link.url} key={link.id}>
              {link.platform === 'facebook' ? <Facebook /> 
              : link.platform === 'twitter' ? <Twitter /> 
              : link.platform === 'instagram' ? <Instagram /> 
              : link.platform === 'website' ? <Language /> 
              : link.platform === 'linkedin' ? <LinkedIn />
              : link.platform === 'github' ? <GitHub />
              : null}
          </IconButton>
      ))}
    </div>
  )
}
